var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.articles.length > 0)?_c('div',{staticClass:"row align-content-lg-stretch"},_vm._l((_vm.articles),function(article){return _c('div',{key:`CatalogArticles-ArticleBox-${article._id}`,staticClass:"col-24 col-md-12 col-lg-8 d-flex mb-3"},[_c('ArticleBox',{attrs:{"article":article}})],1)}),0):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }